import { SelectController } from "./SelectController";

// checkbox = même fonctionnement que slct (sélecteur modal + max/auto-accept).
// Était une copie byte-à-byte de SelectController (ha/444) → on hérite pour
// éliminer la duplication tout en gardant une classe distincte (dispatch
// ControllerRegistry "checkbox", point d'extension futur si le comportement
// doit diverger).
export class CheckboxController extends SelectController {
}
